export enum WidgetsSections {
  RETRO_BONUSES = 'retro_bonuses',
}
